export default {
  PASSWORD_MATCH: 'As palavras-passe não coincidem.'
};
